export default __webpack_public_path__ + "static/media/copy_link.0f6048e6.svg";